import React from 'react';
import {createRoot} from 'react-dom/client';

import './common/styles/index.scss';
import Up2DateMiniCompare from "./common/components/MiniCompare";

const App = () => {
    if(typeof window.Liferay === 'undefined') {
        // Local development
        window.Liferay = {
            ThemeDisplay: {
                getScopeGroupId: () => {
                    return "43011";
                },
                getPortalURL: () => {
                    return "http://claimparts.local:8080"
                },
                getPathThemeImages: () => {
                    return 'http://claimparts.local:8080/o/claimparts-theme/images'
                }
            },
            Util: {
                fetch: window.fetch.bind(window)
            },
            Language: {
                get: (key) => {return key;}
            },
            on: () => {console.log("Not implemented for local development")},
            fire: () => {console.log("Not implemented for local development")},
            detach: () => {console.log("Not implemented for local development")},
        };
    }
    return (
        <Up2DateMiniCompare/>
    );
};

class WebComponent extends HTMLElement {
    connectedCallback() {
        this.root = createRoot(this);
        this.root.render(<App  />);
    }

    disconnectedCallback() {
        this.root.unmount();
        delete this.root;
    }
}

const ELEMENT_ID = 'up2date-mini-compare';

if (!customElements.get(ELEMENT_ID)) {
    customElements.define(ELEMENT_ID, WebComponent);
}
